import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import StartModeViewController from 'automation-ui-canvas/containers/flow-views/test-flow/StartModeViewController';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EnrollmentValidationResultAccordion from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/EnrollmentValidationResultAccordion';
import FlowRevision from 'automation-ui-canvas/flow/records/Flow/FlowRevision';
import FlowAlertView from 'automation-ui-canvas/containers/flow-views/test-flow/FlowAlertView';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import { H5 } from 'UIComponents/elements/headings';
import ValidationLabelIcon from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/ValidationLabelIcon';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import { getExistingTriggerType } from 'automation-ui-enrollment/utils/EnrollmentDeciders';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import { useEffect, useState } from 'react';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SimulationStartSection = ({
  enrollType,
  setEnrollType,
  viewData,
  flow,
  timestamp,
  onCancel
}) => {
  var _viewData$validationC, _enrollmentAlert$aler, _enrollmentAlert$aler2;
  const {
    alerts: {
      enrollmentAlert
    },
    simulatedEnrollmentResult,
    recordId
  } = viewData;
  const flowRevision = new FlowRevision(Object.assign({
    flow: flow.toHybridFlowInterface()
  }, flow)).toHydratedHybridFlowRevision();
  const validationChecks = (_viewData$validationC = viewData.validationChecks) !== null && _viewData$validationC !== void 0 ? _viewData$validationC : [];
  const triggerType = getExistingTriggerType(flow.toHybridFlowInterface());
  const enrollmentCriteria = flow.enrollmentCriteria;
  const refinementCriteria = !enrollmentCriteria || enrollmentCriteria.triggerType !== 'EVENT' ? undefined : enrollmentCriteria.refinementCriteria;

  /*
  Loading state for switching modes.
  Without this we could showing flashes of old data that is associated with the wrong mode.
  This is because in certain cases, the data is stale but not cleared until the next render cycle
  */
  const [isLocalLoading, setIsLocalLoading] = useState(false);
  useEffect(() => {
    if (isLocalLoading && !viewData.isLoading) {
      setIsLocalLoading(false);
    }
  }, [isLocalLoading, viewData.isLoading]);
  const simulationContent = /*#__PURE__*/_jsxs(_Fragment, {
    children: [(enrollmentAlert === null || enrollmentAlert === void 0 ? void 0 : enrollmentAlert.alert) && /*#__PURE__*/_jsx(FlowAlertView, {
      flow: flow,
      viewData: viewData,
      alert: enrollmentAlert.alert,
      onCancel: onCancel
    }), (!enrollmentAlert || enrollmentAlert.shouldShowValidationChecks) && validationChecks.length > 0 && /*#__PURE__*/_jsxs("div", {
      className: "m-top-3",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.testV2.simulatePanel.startSection.startConditionsChecks"
        })
      }), triggerType === 'EVENT' && refinementCriteria && /*#__PURE__*/_jsx(UIAccordionItem, {
        title: /*#__PURE__*/_jsxs(H5, {
          children: [/*#__PURE__*/_jsx(ValidationLabelIcon, {
            status: simulatedEnrollmentResult === 'WOULD_NOT_ENROLL_NOT_IN_REFINE_BY_LIST' ? 'FAILED' : enrollType === 'DYNAMIC' ? 'PASSED' : 'NOT_APPLICABLE'
          }), /*#__PURE__*/_jsx(View, {
            marginInlineStart: "200",
            display: "inline-block",
            position: "relative",
            insetBlockStart: "50",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: simulatedEnrollmentResult === 'WOULD_NOT_ENROLL_NOT_IN_REFINE_BY_LIST' ? 'automation.testV2.simulatePanel.startSection.doesNotMeetRefinement' : 'automation.testV2.simulatePanel.startSection.meetsRefinement'
            })
          })]
        }),
        children: /*#__PURE__*/_jsx("div", {
          className: "m-bottom-3",
          children: /*#__PURE__*/_jsx(ListSegmentationFilters, {
            objectTypeId: flow.objectTypeId,
            value: refinementCriteria,
            readOnly: true
          })
        })
      }), validationChecks.map((validationCheck, index) => {
        return /*#__PURE__*/_jsx(EnrollmentValidationResultAccordion, {
          flowRevision: flowRevision,
          validationResult: validationCheck,
          objectId: recordId
        }, index);
      })]
    })]
  });
  return /*#__PURE__*/_jsxs(UIExpandableSection, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.testV2.simulatePanel.startSection.title"
    }),
    actions: /*#__PURE__*/_jsxs(_Fragment, {
      children: [timestamp && /*#__PURE__*/_jsx(Text, {
        as: "small",
        use: "help",
        marginInlineEnd: "200",
        display: "block",
        children: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
          value: timestamp,
          format: "l LT z"
        })
      }), !isLocalLoading && (enrollmentAlert === null || enrollmentAlert === void 0 ? void 0 : enrollmentAlert.alert) && (enrollmentAlert === null || enrollmentAlert === void 0 || (_enrollmentAlert$aler = (_enrollmentAlert$aler2 = enrollmentAlert.alert).getIcon) === null || _enrollmentAlert$aler === void 0 ? void 0 : _enrollmentAlert$aler.call(_enrollmentAlert$aler2))]
    }),
    defaultOpen: true,
    children: [/*#__PURE__*/_jsx(StartModeViewController, {
      value: enrollType,
      onChange: newMode => {
        setEnrollType(newMode.value);
        setIsLocalLoading(true);
      }
    }), !isLocalLoading && simulationContent]
  });
};
export default SimulationStartSection;